var map = {
	"./ic-deals-inactive.svg": "70bf",
	"./ic-departments-inactive.svg": "450f",
	"./ic-favorites-inactive.svg": "ebf2",
	"./ic-featured-inactive.svg": "3d06",
	"./ic-home-inactive.svg": "ca6a",
	"./ic-menu-inactive.svg": "04ea",
	"./ic-popular-inactive.svg": "cd95"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cc92";